import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const isDarkModeActive = () => {
  if (typeof window !== 'undefined') {
    return document.documentElement.classList.contains('dark');
  }
  return false;
};

const StyledDialog = styled(Dialog)(({ theme }) => {
  const isDark = isDarkModeActive();
  return {
    "& .MuiBackdrop-root": {
      backdropFilter: "blur(6px)",
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
    "& .MuiPaper-root": {
      border: `1px solid ${isDark ? "#444" : "#d32f2f"}`,
      borderRadius: 12,
      padding: theme.spacing(2),
      backgroundColor: isDark ? "#1f2937" : theme.palette.background.paper,
    },
  };
});

export default function ErrorModal({
  open,
  onClose,
  children,
  title,
  error,
  onRetry,
}) {
  const { t } = useTranslation();

  return (
    <StyledDialog open={open} onClose={onClose}>
      <div className="pt-6 px-4 w-full text-center">
        <div className="w-full flex items-center justify-center">
          <img
            src="/images/error.png"
            alt={t("errorModal.errorImageAlt") || "Error"}
            className="w-[100px] h-[100px] object-cover"
          />
        </div>

        <div className="flex items-center justify-center mt-5">
          <h1 className="text-[24px] dark:text-white">
            {title || t("errorModal.defaultTitle") || "Error"}
          </h1>
        </div>
        <div className="mt-3 w-full dark:text-gray-300">{children}</div>
        <div className="flex items-center justify-center flex-col gap-1 py-3 mt-4 w-full rounded-md bg-[#CD0C021A] dark:bg-red-900/20">
          <h3 className="text-[16px] dark:text-gray-300">
            {error || t("errorModal.defaultError") || "Something went wrong"}
          </h3>
        </div>
        <div className="w-full flex items-center justify-center flex-col">
          {onRetry && (
            <button
              onClick={onRetry}
              className="w-full flex items-center justify-center text-white py-2 px-4 rounded-md mt-3 bg-[#CD0C02] dark:bg-red-700 dark:hover:bg-red-800 transition-colors"
            >
              {t("errorModal.retry") || "Retry"}
            </button>
          )}
          <button
            onClick={onClose}
            className="w-full flex items-center justify-center text-white py-2 px-4 rounded-md mt-1 bg-black dark:bg-gray-700 dark:hover:bg-gray-600 transition-colors"
          >
            {t("errorModal.goBack") || "Go Back"}
          </button>
        </div>
      </div>
    </StyledDialog>
  );
}